export default "__VITE_ASSET__CIyMFr_I__"